import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["innerHTML"]

import { watch } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'account-input',
  props: {
    name: {},
    errorMessage: {},
    title: {}
  },
  emits: ["inputErrorDetected"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

watch(
    () => props.errorMessage,
    (newErrorMessage) => {
        if (newErrorMessage) emit("inputErrorDetected");
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["account-input", { error: _ctx.errorMessage }])
  }, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: "account-input__label",
          for: _ctx.name
        }, _toDisplayString(_ctx.title), 9, _hoisted_1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("div", {
      class: "account-input__error",
      innerHTML: _ctx.errorMessage
    }, null, 8, _hoisted_2)
  ], 2))
}
}

})